import React, { useEffect } from 'react';
import { AlertCircle } from 'react-feather';
import './IncidentToast.css';

export interface IncidentToastProps {
  title: string;
  body?: string;
  onDismiss: () => void;
  onClick?: () => void;
  autoHideMs?: number;
}

export const IncidentToast: React.FC<IncidentToastProps> = ({
  title,
  body,
  onDismiss,
  onClick,
  autoHideMs = 5000,
}) => {
  useEffect(() => {
    const t = setTimeout(onDismiss, autoHideMs);
    return () => clearTimeout(t);
  }, [onDismiss, autoHideMs]);

  return (
    <div
      className="incident-toast"
      role="alert"
      onClick={() => {
        onClick?.();
        onDismiss();
      }}
    >
      <div className="incident-toast-icon">
        <AlertCircle size={20} />
      </div>
      <div className="incident-toast-content">
        <div className="incident-toast-title">{title}</div>
        {body && <div className="incident-toast-body">{body}</div>}
      </div>
      <button
        type="button"
        className="incident-toast-dismiss"
        aria-label="Dismiss"
        onClick={(e) => {
          e.stopPropagation();
          onDismiss();
        }}
      >
        ×
      </button>
    </div>
  );
};
